import { render } from "./appHeader.vue?vue&type=template&id=063a080c"
import script from "./appHeader.vue?vue&type=script&lang=js"
export * from "./appHeader.vue?vue&type=script&lang=js"

import "./appHeader.vue?vue&type=style&index=0&id=063a080c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__